// src/utils/url.js
/**
 * Build a URL with query params, ensuring each value is encoded exactly once.
 * You can pass raw or already-encoded values; we normalize them.
 */
export function buildUrl(base, params = {}) {
    const u = new URL(base, window.location.origin);
    for (const [k, v] of Object.entries(params)) {
        if (v === undefined || v === null || v === "") continue;
        const s = String(v);
        // If it looks encoded, decode once; then URLSearchParams will encode exactly once.
        try {
            u.searchParams.set(k, decodeURIComponent(s));
        } catch {
            u.searchParams.set(k, s);
        }
    }
    return u.toString();
}

/**
 * Encode a single value exactly once (handy for path segments).
 */
export function encodeOnce(v = "") {
    const s = String(v ?? "");
    try { return encodeURIComponent(decodeURIComponent(s)); }
    catch { return encodeURIComponent(s); }
}
